import React, { useState, useEffect } from 'react';
import '../../css/addCardSettings.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import CustomButton from '../../components/CustomButton';
import Heading from '../../components/Heading';
import CustomBreadcrumbsSettings from '../../components/Breadcrumbs/CustomBreadcrumbsSettings';
import imgUnlinkMBOne from '../../assets/img/mb_unlinck_slider/desktop/mb_unlinck_desktop_one.png';
import imgUnlinkMBTwo from '../../assets/img/mb_unlinck_slider/desktop/mb_unlinck_desktop_two.png';
import imgUnlinkMBThree from '../../assets/img/mb_unlinck_slider/desktop/mb_unlinck_desktop_three.png';
import imgUnlinkMBOneMobile from '../../assets/img/mb_unlinck_slider/mobile/mb_unlinck_mobile_one.png';
import imgUnlinkMBTwoMobile from '../../assets/img/mb_unlinck_slider/mobile/mb_unlinck_mobile_two.png';
import imgUnlinkMBThreeMobile from '../../assets/img/mb_unlinck_slider/mobile/mb_unlinck_mobile_three.png';
import imgUnlinkMBOneTablet from '../../assets/img/mb_unlinck_slider/tablet/mb_unlinck_tablet_one.png';
import imgUnlinkMBTwoTablet from '../../assets/img/mb_unlinck_slider/tablet/mb_unlinck_tablet_two.png';
import imgUnlinkMBThreeTablet from '../../assets/img/mb_unlinck_slider/tablet/mb_unlinck_tablet_three.png';
import SliderSettings from '../../components/Sliders/SliderSettings';
import { MdOutlinePhoneInTalk } from "react-icons/md";
import { MdOutlineMail } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import { setCardLimit, setQuantCartoes } from '../../features/onboardingData/onboardingUserData';
import SuspendedWalletAlert from '../../components/SuspendedWalletAlert';
import langTxt from '../../lang/pt.json';

function AddCardSettings() {

    const navigate = useNavigate();
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const isCardLimit = useSelector((state) => state.onboardingUserData.isCardLimit);
    const isQuantCartoes = useSelector((state) => state.onboardingUserData.isQuantCartoes);
    const isStatusCarteira = useSelector((state) => state.onboardingUserData.isStatusCarteira);

    const handleSaudeEmailClick = () => {
        const emailAddress = 'geral@saude360.medis.pt';
        const mailtoLink = `mailto:${emailAddress}`;
    
        window.location.href = mailtoLink;
    }

    const handleMarketPlaceEmailClick = () => {
        const emailAddress = 'marketplace@medis.pt';
        const mailtoLink = `mailto:${emailAddress}`;
    
        window.location.href = mailtoLink;
    }

    const handleActiveEmailClick = () => {
        const emailAddress = 'active@medis.pt';
        const mailtoLink = `mailto:${emailAddress}`;
    
        window.location.href = mailtoLink;
    }

    const handleAddNewCard = () => {
        navigate('/configuracoes/associar-cartao/tipo-de-associacao')
    }

    const handleBtnCall = () => {
        const phoneNumber = '218458888';
        window.location.href = `tel:${phoneNumber}`;
    };

    const handleBtnGoToContacts = () => {
        const element = document.getElementById('contactMainContainerAddCardSettings');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const mbData = [
        {
          "imgUnlinkCard": {
            "desktop": imgUnlinkMBOne,
            "tablet": imgUnlinkMBOneTablet,
            "mobile": imgUnlinkMBOneMobile,
          },
          "titleUnlinkCard": langTxt.UnlinkCardMB.part1.title,
          "txtUnlinkCard": langTxt.UnlinkCardMB.part1.desc,
          "descUnlinkCard": langTxt.UnlinkCardMB.part1.descSec
        },
        {
          "imgUnlinkCard": {
            "desktop": imgUnlinkMBTwo,
            "tablet": imgUnlinkMBTwoTablet,
            "mobile": imgUnlinkMBTwoMobile,
          },
          "titleUnlinkCard": langTxt.UnlinkCardMB.part2.title,
          "txtUnlinkCard": langTxt.UnlinkCardMB.part2.desc,
          "descUnlinkCard": langTxt.UnlinkCardMB.part2.descSec
        },
        {
          "imgUnlinkCard": {
            "desktop": imgUnlinkMBThree,
            "tablet": imgUnlinkMBThreeTablet,
            "mobile": imgUnlinkMBThreeMobile,
          },
          "titleUnlinkCard": langTxt.UnlinkCardMB.part3.title,
          "txtUnlinkCard": langTxt.UnlinkCardMB.part3.desc,
          "descUnlinkCard": langTxt.UnlinkCardMB.part3.descSec
        }
    ]
    
    return (  
        <>
        <Header/> 
        <div className={ isTablet ? "mainViewContainerAddCardSettings" : ( isMobile ? 'mainViewContainerAddCardSettingsTablet' : 'mainViewContainerAddCardSettingsMobile') }>
            <div className={ isTablet ? 'firstTxtViewContainerAddCardSettings' : ( isMobile ? 'firstTxtViewContainerAddCardSettingsTablet' : 'firstTxtViewContainerAddCardSettingsMobile') }>
                <div style={ isTablet ? { width: '100%', height: '100%', marginBottom: '48px', marginTop: '-48px' } :  ( isMobile ? { width: '100%', height: '100%', paddingInline: '40px', paddingTop: '-48px' } : { width: '100%', height: '100%', paddingInline: '16px' })}>
                    { (isStatusCarteira ===  '2')  &&
                        <SuspendedWalletAlert onPress={handleBtnGoToContacts} />
                    }
                </div>
                <div className='mainHeadingViewContainerAddCardSettings'> 
                    <CustomBreadcrumbsSettings hasPadding hasSettings hasAddCard />
                    <Heading hasPadding hasBtnBack={false}/>
                </div>
                <div className={ isTablet ? 'secondMainContainerAddCardSettings' : ( isMobile ? 'secondMainContainerAddCardSettingsTablet' : 'secondMainContainerAddCardSettingsMobile') }>
                    <div className={ isTablet ? 'firstSubMainContainerAddCardSettings' : 'firstSubMainContainerAddCardSettingsMobile' }>
                        <div className='secondTitleViewAddCardSettings'>
                            <div className={ isTablet ? 'textTitleRegular400AddCardSettings' : ( isMobile ? 'textTitleRegular400AddCardSettingsTablet' : 'textTitleRegular400AddCardSettingsMobile') }>Associar cartões</div>
                        </div>
                        <div className='txtSecondTitleViewAddCardSettings'>
                            <div className='textSecondTitleViewAddCardSettings'>
                                { !isCardLimit ? 
                                    <>
                                        {'Pode associar até um máximo de 5 cartões.'}
                                        <br/>
                                        {`Pode associar ainda mais ${isQuantCartoes} cartões à sua carteira Médis.`}
                                    </>
                                    :
                                    'Já chegou ao limite de cartões bancários que pode associar à sua carteira Médis. Se desejar remover algum cartão, siga os passos abaixo.'
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className='btnMainViewContainerAddCardSettings'>
                    <CustomButton 
                        text={'Associar novo cartão'} 
                        textColor={'#00214D'}
                        onPress={handleAddNewCard} 
                        color={'#15D4B6'}
                        hasArrow
                        iconColor={'#00214D'}
                        enabled={!isCardLimit}
                    />
                </div>
                <div className={ isTablet ? 'secondSubMainContainerAddCardSettings' : 'secondSubMainContainerAddCardSettingsMobile' }>
                    <div className='secondTitleViewAddCardSettings'>
                        <div className={ isTablet ? 'textTitleRegularSecondSubMainContainerAddCardSettings' : ( isMobile ? 'textTitleRegularSecondSubMainContainerAddCardSettingsTablet' : 'textTitleRegularSecondSubMainContainerAddCardSettingsMobile') }>Desassociar um cartão da sua carteira</div>
                    </div>
                    <div className={ isTablet ? 'txtSecondTitleSubMainViewContainerAddCardSettings' : 'txtSecondTitleSubMainViewContainerAddCardSettingsMobile' }>
                        {/* <div className='textSecondTitleSecondSubMainContainerAddCardSettings'>Lorem ipsum</div> */}
                    </div>
                    <div className={isTablet ? 'mainSliderViewContainerAddCardSettings' : ( isMobile ? 'mainSliderViewContainerAddCardSettingsTablet' : 'mainSliderViewContainerAddCardSettingsMobile')}>
                        <SliderSettings
                            listRespData={mbData}
                        />
                    </div>
                </div>
            </div>
            <div id='contactMainContainerAddCardSettings' className={ isTablet ? 'secondMainViewContainerAddCardSettings' : ( isMobile ? 'secondMainViewContainerAddCardSettingsTablet' : 'secondMainViewContainerAddCardSettingsMobile' ) }>
                <div className='infroMainCardViewAddCardSettings'>
                    <div className='contactInfoBoxRowViewAddCardSettings'>
                        <div className='emailIconSvgInfoBoxViewAddCardSettings'><MdOutlineMail className='emailIconSvgInfoBoxAddCardSettings' /></div>
                        <div className='txtRegularInfoBoxAddCardSettings'>Email <span className='txtSemiBoldInfoBoxAddCardSettings'>Médis Saúde 360</span></div>
                    </div>
                    <div className='contactInfoBoxColumnViewAddCardSettings'>
                        <div className='txtEmailRegularInfoBoxAddCardSettings'>geral@saude360.medis.pt</div>
                    </div>
                    <div className={ isTablet ? 'btnInfoBoxViewAddCardSettings' : 'btnInfoBoxViewAddCardSettingsMobile' }>
                        <CustomButton 
                            text={'Enviar email'} 
                            textColor={'#141414'}
                            borderColor={'#141414'}
                            hasShadow={false}
                            hasArrow
                            iconColor={'#141414'}
                            iconType={'email'}
                            onPress={handleSaudeEmailClick}
                        />
                    </div>
                </div>
                <div className='infroMainCardViewAddCardSettings'>
                    <div className='contactInfoBoxRowViewAddCardSettings'>
                        <div className='emailIconSvgInfoBoxViewAddCardSettings'><MdOutlinePhoneInTalk className='emailIconSvgInfoBoxAddCardSettings' /></div>
                        <div className='txtRegularInfoBoxAddCardSettings'>Telefone <span className='txtSemiBoldInfoBoxAddCardSettings'>Médis Saúde 360</span></div>
                    </div>
                    <div className='mainSecondContactInfoBoxColumnViewAddCardSettings'>
                        <div className='txtEmailSemiBoldInfoBoxAddCardSettings'>210 204 887</div>
                        <div className='contactInfoBoxColumnViewAddCardSettings'>
                            <div className='txtEmailRegularInfoBoxAddCardSettings'>De segunda a sexta, das 9h às 18h.</div>
                            <div className='txtEmailRegularInfoBoxAddCardSettings'>Custo de chamada para rede fixa nacional.</div>
                        </div>
                    </div>
                    <div className={ isTablet ? 'btnInfoBoxViewAddCardSettings' : 'btnInfoBoxViewAddCardSettingsMobile' }>
                        <CustomButton 
                            text={'Ligar'} 
                            textColor={'#141414'}
                            borderColor={'#141414'}
                            hasShadow={false}
                            hasArrow
                            iconColor={'#141414'}
                            iconType={'phone'}
                            onPress={handleBtnCall}
                        />
                    </div>
                </div>
            </div>
        </div>
        <Footer/> 
        </>
    )
}

export default AddCardSettings;